export default "__VITE_ASSET__CuBK_839__"